import { createSlice } from '@reduxjs/toolkit';

const initialAuthState = {
	isLoggedIn: JSON.parse(sessionStorage.getItem('login'))?.login ? true : false,
	isPFM: false,
};

const authSlice = createSlice({
	name: 'auth',
	initialState: initialAuthState,
	reducers: {
		login(state) {
			state.isLoggedIn = true;
		},
		logout(state) {
			sessionStorage.clear();
			state.isLoggedIn = false;
		},
		setPFMFlag(state, action) {
			state.isPFM = action.payload;
		},
	},
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
